import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Table, Dropdown, Input, } from 'semantic-ui-react'
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { Config } from "../../common"
import { Loading, NoOrderHistory } from "../../components"
import { getOrders } from '../../store/OrderRedux'
import { useTranslation } from "react-i18next";
import searchicon from "../../assets/home/searchicon.svg";

const ParticipationDetails = (props) => {
    const { match } = props;
    const dispatch = useDispatch()
    const history = useHistory();
    const token = useSelector((state) => state.auth.token)
    const isFetching = useSelector((state) => state.order.isFetching)
    const [search, setSearch] = useState('')
    const timer = useRef();
    const contests = useSelector((state) => state.order.orders)
    const partDetails = useSelector((state) => state.order.partDetails)
    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0)
        if (match.params.id) {
            dispatch(getOrders({ token, triviaId: match.params.id }))
        }
    }, []);

    const handleSearch = (value) => {
        setSearch(value)
        let param = { token, triviaId: match.params.id }
        if (value) {
            param.code = value
        }
        clearInterval(timer.current);
        timer.current = setTimeout(() => {
            dispatch(getOrders(param))
        }, 500)
    }

    if (isFetching) {
        return <Loading />
    }


    return (
        <div className="container">
            <div className="Participation" style={{ marginTop: "30px" }} >
                <h4>Participation <span>History</span> </h4>
                <p>Select the appropriate contest you want to view details</p>
            </div>
            {partDetails ? <div className="paticitions">
                <Grid>
                    <Grid.Row>
                        <Grid.Column className="paticition_card" mobile={16} tablet={5} computer={5}>
                            <h5>{partDetails.triviaName}</h5>
                            <h6>{partDetails.triviaDescription}</h6>
                        </Grid.Column>
                        <Grid.Column className="paticition_card" mobile={16} tablet={5} computer={5}>
                            <h5>{moment.utc(partDetails?.trivia?.endDate).format('Do MMM, YYYY')}</h5>
                            <h6>The contest you’ve entered will end by this date</h6>
                        </Grid.Column>
                        <Grid.Column className="paticition_card" mobile={16} tablet={5} computer={5}>
                            <h5>{Config.parseDuration(partDetails?.trivia?.leaderTime)}</h5>
                            <h6>The leader’s time for this particular contest, try again to beat and become one of #top100</h6>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div> : null}
            <div className="input_boxs partic">
                <div className="input_text" Stackable>
                    <div className="search_sec">
                        <img className="searchicon" src={searchicon} />
                        <Input value={search} onChange={(e) => handleSearch(e.target.value)} placeholder='Search' />
                    </div>
                </div>
            </div>
            <>
                {contests.length > 0 ? <div className="inner_bg destops">
                    <div className="celebrity">
                        <Table>
                            <Table.Row>
                                <Table.HeaderCell><h4>Order ID </h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>Date</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>Timer</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>Result</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>Amount</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>summary</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>reward</h4></Table.HeaderCell>
                                <Table.HeaderCell><h4>Invoice</h4></Table.HeaderCell>
                            </Table.Row>
                        </Table>
                    </div>
                    <div className="scrolls-y" style={{ height: 400 }}>
                        <div className="text"></div>
                        {contests.map((item, key) => <div key={key} className="amount">
                            {(item?.contestant?.winner) ? <div className="top_list top_list3"><span>#Top 100</span></div> : null}
                            <Table>
                                <Table.Row>
                                    <Table.HeaderCell><h4>#{item.code}</h4></Table.HeaderCell>
                                    <Table.HeaderCell><h4>{moment.utc(item?.contestant?.createdAt).format('Do MMM YYYY')}</h4></Table.HeaderCell>
                                    <Table.HeaderCell><h4>{Config.parseDuration(item?.contestant?.timeTaken)}</h4></Table.HeaderCell>
                                    <Table.HeaderCell><h4>{item?.contestant?.score}/{item?.contestant?.attemptedQuestions}</h4></Table.HeaderCell>
                                    <Table.HeaderCell><h4>₹ {item.entryFees}</h4></Table.HeaderCell>
                                    <Table.HeaderCell style={{ cursor: 'pointer' }} onClick={() => {
                                        history.push(`/contesthistory/${item._id}`)
                                    }}><a>Summary</a></Table.HeaderCell>
                                    <Table.HeaderCell style={{ cursor: 'pointer' }} onClick={() => {
                                        history.push(`/rewards`)
                                    }}><a>Reward</a></Table.HeaderCell>
                                    <Table.HeaderCell><a href="#">Download Invoice</a></Table.HeaderCell>
                                </Table.Row>
                            </Table>
                        </div>)}
                        <div className="text"></div>
                    </div>
                </div> : <NoOrderHistory />}

                <div className="mobiles clearall scrolls-y" style={{ height: 400 }}>
                    {contests ? contests.map((item, key) => {
                        let basicDetails = Config.GetLanguage(item, i18n.language, 'basicDetails')
                        return <div key={key} className="sarukhu mobiles">
                            {(item?.contestant?.winner) && (<div className="top_list"><span>#Top 100</span></div>)}


                            <div style={{ textAlign: 'center', padding: '0px 0', marginBottom: '-15px' }}>
                                <h4
                                //  onClick={() => {
                                //     history.push(`/contesthistory/${item._id}`)}}
                                >ORDER ID: {item?.code}</h4>
                                <h5>Result : {item?.contestant?.score}/{item?.contestant?.attemptedQuestions}</h5>
                            </div>

                            <div className="answered">
                                <h4>Date : {moment.utc(item?.contestant?.timeStarted).format('Do MMM YYYY')}</h4>
                                <h4>Time: {Config.parseDuration(item?.contestant?.timeTaken)}</h4>
                            </div>
                            <div className="answered">
                                <h4>Latest entry :{moment.utc(item?.contestant?.timeStarted).format('Do MMM YYYY')}</h4>
                                <h4>End date : {moment.utc(item?.contestant?.timeEnded).format('Do MMM YYYY')}</h4>
                            </div>
                            <div className="answered">
                                <h3><a onClick={() => {
                                    history.push(`/contesthistory/${item._id}`)
                                }}> View Summary</a></h3>
                            </div>
                            <div className="answered answere_sec">
                                <Grid>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <h3><a onClick={() => {
                                                history.push(`/rewards`)
                                            }}>View reward</a></h3>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <h3><a href="#"> Download Invoice</a></h3>
                                        </Grid.Column>

                                    </Grid.Row>
                                </Grid>
                            </div>
                        </div>
                    }) : null}
                </div>


            </>
        </div>
    );
};

export default ParticipationDetails